export default {
    Language:'语言',
    ContactUs:'联系我们',
    EnterpriseWeChat:'企业微信',
    OnlineConsultant:'在线咨询',
    OnLineService:'达安在线咨询',
    ViewAll:'查看全部',
    HotRecommends:'热点推荐',
    ViewDetails:'查看详情',
    WhatCanWeDoForYou:'我们能为您做什么',
    Detail:'详情',
    Contact:'联系',
    RelevantPolicyTrends:'相关政策动态',
    MoreDynamic:'更多动态',
    LoyaltyToDataWinsTrust:'忠于数据 赢得信赖',
    Customers:'合作客户',
    Business:'业务分布',
    OfficialAccounts:'公众号',
    Douyin:'抖音视频号',
    FriendlyLink:'友情链接',
    BeforeService:'售前服务',
    AllRightsReserved:'版权所有',
    CompanyName:'襄阳达安汽车检测中心有限公司',
    Overview:'概述',
    Summary:'综述',
    CoreAdvantage:'核心优势',
    CharacteristicCase:'特色案例',
    MainContent:'主要内容',
    MajorOrientation:'专业方向',
    Close:'关闭',
    ContactNumber:'联系电话',
    Home:'首页',
    Search:'搜索',
    CoreCompetencies:'核心能力',
    CharacteristicAdvantage:'特色优势',
    ExcellentCase:'优秀案例',
    TechnologyConsulting:'技术咨询',
    LoadMore:'加载更多',
    NoData:'暂无数据',
    Source:'来源',
    GoBack:'返回列表',
    PublishTime:'发布时间',
    DAANVOICE:'达安之声',
    RECENTNEWS:'最近新闻',
    MORE:'更多',
    ADDRESS:'地址',
    People:'名',
    ResumeDownload:'简历下载',
    JoinDaan:'加入达安',
    JoinDes:'面向全球诚揽各专业高级专家型人才，全方面提供良好科研环境和创新土壤',
    EmployeeActivity:'员工活动',
    EmployeeActivityDes:'共同建设世界一流汽车技术服务企业',
    StaffPresence:'员工风采',
    StaffPresenceDes:'共同建设世界一流汽车技术服务企业',
    TalentStrategy:'人才战略',
    TalentStrategyDes:'面向全球诚揽各专业高级专家型人才，全方面提供良好科研环境和创新土壤',
    LearnMore:'了解更多',
    JoinUs:'加入我们',
    JoinUsDes:'邀请您【共同建设世界一流汽车技术服务企业】',
    Delivery:'投递简历',
    DownloadResumeTemplate:'下载简历模版',
    Founded:'始建',
    FloorSpace:'占地面积',
    CurrentStaff:'现有员工',
    Detectability:'检测能力',
    Year:'年',
    HistoricalDevelopment:'历史沿革',
    InstitutionalAccreditation:'机构认可',
    EnterKeywordsToSearchForJobs:'输入关键词搜索职位',
    ServiceScope:'服务领域',
    ServicePromise:'服务承诺',
    OneStopShop:'一站式服务',
    BusinessDivision:'襄阳本部、武汉子公司、工作部/海外事业部',
    InputKeyword:'请输入关键字',
    DeliveryEmail:'投递邮件',
    Governmentwebsite:'政府网站',
    CentralNetworkGroup:'中心网群',
    IndustryBody:'行业机构',
    Send:'发送',
    PleaseEnter:'请输入文字',
    EnterpriseCentralPartner:'央企伙伴',
    CarPartner:'汽车伙伴',
    Me:'我',
    ClienteleServices:'技术咨询',
    BrandIntroduction:'品牌介绍',
    OffRoadGuideDatabase:'越野指南库',
    DownloadCenter:'下载中心',
    LatestUpdates:'最新动态',
    LatestEvaluationModel:'最新测评车型/路线测试（后期）',
    ViewAllResults:'查看所有结果',
    RegulationsFileDownload:'规程文件下载',
    DownloadEvaluationResults:'测评结果下载',
    ViewMore:'查看更多',
    More:'更多',
    FrontlineEvaluation:'测评前线',
    EvaluationModelAnnounced:'测评车型公布',
    MediaReports:'媒体报道',
    IndustryNews:'行业资讯',
    Download:'下载',


}